import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';

import * as yup from "yup";


export interface IRulesPerBINFormMeta {
  idBank: FormInputMeta,
  nameBank: FormInputMeta,
  idSystem: FormInputMeta,
  nameSystem: FormInputMeta,
  // Schema
  schema: any,
}

const RulesPerBINFormMeta = {} as IRulesPerBINFormMeta;

RulesPerBINFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID Banque',
  placeholder: '',
  validation: yup.string().required(),
};
RulesPerBINFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Nom Banque',
  placeholder: '',
  validation: yup.string().required(),
};

RulesPerBINFormMeta.idSystem = {
  name: 'idSystem',
  type: 'text',
  label: 'ID Système',
  placeholder: '',
  validation: yup.string().required(),
};
RulesPerBINFormMeta.nameSystem = {
  name: 'nameSystem',
  type: 'text',
  label: 'Nom Système',
  placeholder: '',
  validation: yup.string().required(),
};


RulesPerBINFormMeta.schema = yup.object().shape(getValidationSchema(RulesPerBINFormMeta));

export default RulesPerBINFormMeta;